// START Open Require.JS wrapper
define([
	'jquery',
	'pubsub',
	'shared.main.screen'
	], function($,pubsub,screenSize) {
// END Open Require.JS wrapper


	/****
	 * Controls sticky navigation for medium and large screens 
	 ***/
	var DEBUG = false;
	var PLUGIN_IDENTIFIER = "topnavSticky";
	var topnavSticky;
	var promoBarTopEnabled = WCS_CONFIG.get('topnav::promoBarTopEnabled') || false;
	var tnfTopNavNewDesignEnabled = WCS_CONFIG.get('topnav::aemTopnavNewDesignEnabled') || false;
	var vansTopNavNewDesignEnabled = WCS_CONFIG.get('topnav::aemTopnavStyleContainerEnabled') || false;
	var topNavToggleScrollDisabled = WCS_CONFIG.get('topnav::topNavToggleScrollDisabled') || false;
	var newStickyTopEnabled = WCS_CONFIG.get('topnav::newStickyTopEnabled') || false;
	var lastScroll = 0;
	var topNavBodyPadding = 0;

	(function(){
		topnavSticky = {
			defaults: {
				el: ".topnav-header",
				dataAttr: "topnav-sticky-options",
				topnavAccordion: '.topnav-accordion',
				mainnav: '.topnav-mainnav',
				search: '.topnav-search-container',
				promobar: '.topnav-promobar',
				promobarContainer: '.topnav-promobar-container',
				cart: '.topnav-cart a',
				logo: '.topnav-logo',
				smallHeader: '.topnav-smallheader-container',
				topnav: '.topnav',
				scroll: '160',
				transitionTimeoutDelay: 10,
				topNavNewHeader: '.top-nav-header',
				searchButton: ".topnav-searchbutton",
			},

			/**
			 * Initialize Topnav Sticky Functions
			 **/
			init : function() {
				if ( DEBUG ) console.log('initilizing ' + PLUGIN_IDENTIFIER);

				if(tnfTopNavNewDesignEnabled) {
					$("body").addClass("aem-new-topnav-design");
				}

				var self = this;
				self.deferred = $.Deferred();

				self.$element = $(self.defaults.el);
				self.metadata = self.$element.data(self.defaults.dataAttr);
				self.config = $.extend( {}, self.defaults, self.metadata );

				self.calculateStickyScrollTrigger();

				// cache dom elements
				self.config.$header = self.$element;
				self.config.$mainnav = $(self.config.mainnav);
				self.config.$accordion = self.config.$header.find(self.config.topnavAccordion);
				self.config.$smallHeader = self.config.$header.find(self.config.smallHeader);
				self.config.$topnav = self.config.$header.closest(self.config.topnav);
				self.config.$promobar = self.config.$topnav.find(self.config.promobar);
				self.config.$promobarContainer = self.config.$topnav.find(self.config.promobarContainer);
				self.config.$search = self.config.$header.find(self.config.search);
				self.config.$searchButton = $(self.config.searchButton);
				topNavBodyPadding = self.config.$header.outerHeight();

				if(self.config.$header.hasClass('sticky-animate')) {
					self.config.animate = true;
				}

				if(self.config.$topnav.closest('.transperant-topnav').length) {
					self.config.isNavTransparent = true;
				}

				self._build();

				self.events();

				self.deferred.resolve();

				return self;
			},

			/**
				* Sticky events
				**/
			events : function() {
				var self = this;

				// Bind Scroll events to add minimized sticky nav functionality
				if((self.config.isNavTransparent || screenSize.size() !== 'small') && self.config.$header.hasClass('sticky-medium')) {
					window.addEventListener('scroll',function(event) {
						self.toggleScrollEvents(self);
					});
				}

				// subscribe to topnav accordion menu events
				self.bindTopnavAccordionEvents();

				// Resizing window to small will unbind scroll events and bind events if they are not already bound
				$.pubsub('subscribe','window.resize.breakpoint', function(event,data) {
					if(data.now === 'small') {
						self.unbindScrollEvents();
					} else {
						var windowScrollEvents = $._data(window, "events").scroll,
							currentWindowScrollEvents;

						if(typeof windowScrollEvents != "undefined") {
							currentWindowScrollEvents = $.grep(windowScrollEvents, function (n, i) {
								return (n.data === self);
							});
						}

						// rebind scroll events for medium/large
						if(!windowScrollEvents || currentWindowScrollEvents.length <= 0) {
							$(window).on('scroll', self, self.toggleScrollEvents);
						}
					}

					// Recalculate body padding
					self.updateBodyPadding();
				});
			},

			bindTopnavAccordionEvents: function() {
				var self = this;

				// listen for menu to open
				$.pubsub('subscribe', 'vfdp.aem.topnav.accordion.open', function(event,data) {
					if(screenSize.size() === "small") {
						self.updateBodyPadding(true);
					}
				});

				// listen for menu to close
				$.pubsub('subscribe', 'vfdp.aem.topnav.accordion.close', function(event,data) {
					if(screenSize.size() === "small") {
						self.updateBodyPadding();
					}
				});
			},

			/**
			 * Calculates the padding needed to offset the body element
			 * so that page contents are not overlapped by the top nav
			 *
			 * @param boolean to indicate whether method was called when topnav accordion is opened
			 */
			calculateBodyPadding: function(topnavAccordionOpen, breakpoint) {
				var self = this;

				if( topnavAccordionOpen ) {
					return self.config.$smallHeader.outerHeight();
				}

				if(self.config.isNavTransparent) {
					return self.config.$promobar.length ? self.config.$promobar.outerHeight() : 0; //for transparent headers keep only promobar's height as padding
				}

				if(tnfTopNavNewDesignEnabled) {
					return self.config.$header.outerHeight();
				}

				return self.config.$header.outerHeight() + self.config.$promobar.outerHeight();
			},

			/**
			 * Updates the padding on the body element so that page
			 * contents are not overlapped by the top nav
			 *
			 * @param boolean to indicate whether method was called when topnav accordion is opened
			 **/
			updateBodyPadding: function(topnavAccordionOpen, breakpoint) {
				var self = this,
					padding = ''; // Default to remove the inline CSS property

				if(typeof breakpoint === "undefined") breakpoint = screenSize.size();

				if( self.config.$header.hasClass('sticky-' + breakpoint) ) {
					padding = self.calculateBodyPadding(topnavAccordionOpen, breakpoint);
				}

				if(self.config.isNavTransparent) {
					self.config.$header.css('top', padding); // leave padding for the promobar to be positioned
				}
				if(vansTopNavNewDesignEnabled && topnavAccordionOpen) {
					$('body').css('padding-top', topNavBodyPadding);
					return;
				}
				$('body').css('padding-top', padding);
			},

			calculateStickyScrollTrigger: function() {
				var self = this;
				self.defaults.scroll = self.$element.outerHeight() || self.defaults.scroll;
			},
			toggleTransperantTopNav: function() {
				var self = this;
				
                if(!self.config.isNavTransparent) return;

                var self = this,
                topNavNewBar = $(self.config.topNavNewHeader);
				var currentScroll = $(window).scrollTop();

				if(currentScroll >= self.config.scroll) {
					self.config.$header.addClass('sticky-animation');
				} else if(currentScroll <= 1){
					self.config.$header.removeClass('sticky-animation');
				}
				if(currentScroll > 0 && currentScroll < lastScroll) {
					topNavNewBar.addClass('new-transperant-topnav')
				} else {
					if(screenSize.size() !== 'small' || (screenSize.size() === 'small' && currentScroll <= self.config.scroll && !self.config.$searchButton.hasClass('active'))) {
						topNavNewBar.removeClass('new-transperant-topnav')
						self.updateBodyPadding();
					}
				} 
				lastScroll = currentScroll;
			},

			minimizeStickyHeader: function(restrictAnimations) {
				var self = this;

				// minimize the sticky header
				self.config.$header.addClass('sticky-minimized');
				if(self.config.$header.hasClass('tnf-top-nav-new-design') && screenSize.size() === 'medium' && screenSize.size() !== 'large') {
					self.config.$header.removeClass('sticky-minimized');
				}
				// hide the promobar
				if(!promoBarTopEnabled) {
					self.config.$promobar.addClass('hide');
				}

				// dispatch change for minimized sticky header
				$.pubsub('publish', 'vfdp.topnav.sticky.minimized');

				// when the header animations are complete, fade in the search box and remove event listener
				var headerAnimationComplete = function(event) {
					// transition events bubble up from children so detect transition on the header
					if(event.target == self.config.$header[0]) {
						self.config.$search.removeClass('notransition fade-out');
						self.config.$mainnav.removeClass('notransition fade-out');
						self.config.$header[0].removeEventListener('transitionend', headerAnimationComplete);

						// dispatch transitionend for minimized sticky header
						$.pubsub('publish', 'vfdp.topnav.sticky.transitionend.minimized');
					}
				};

				// if animations are enabled, add classes to trigger transitions and handle transitionend
				if(!restrictAnimations && this.config.animate) {
					self.config.$search.addClass('notransition fade-out');
					self.config.$mainnav.addClass('notransition fade-out');
					self.config.$header[0].addEventListener('transitionend', headerAnimationComplete);
				}
			},

			maximizeStickyHeader: function(restrictAnimations) {
				var self = this;

				// maximize the sticky header
				self.config.$header.removeClass('sticky-minimized');

				// dispatch change for maximized sticky header
				$.pubsub('publish', 'vfdp.topnav.sticky.maximized');

				// when promobar slides in, remove masking on the container and remove event listsner
				var promoAnimationComplete = function() {
					self.config.$promobarContainer.removeClass('mask');
					self.config.$promobar[0].removeEventListener('transitionend', promoAnimationComplete);
				};

				// when header animations complete, transition the search container and promobar, remove event listener
				var headerAnimationComplete = function(event) {
					// transition events bubble up from children so detect transition on the header
					if(event.target == self.config.$header[0]) {
						self.config.$search.removeClass('notransition fade-out');
						self.config.$mainnav.removeClass('notransition fade-out');
						self.config.$header[0].removeEventListener('transitionend', headerAnimationComplete);

						// mask the container and prep promobar to slide down
						self.config.$promobarContainer.addClass('mask');
						self.config.$promobar.removeClass('hide notransition');
						self.config.$promobar.addClass('slide-up');
						self.config.$promobar[0].addEventListener('transitionend', promoAnimationComplete);

						// a slight delay is needed for transitions to work after removing the hide class
						self.config.timeout = window.setTimeout(function () {
							self.config.$promobar.removeClass('slide-up');
							window.clearTimeout(self.config.timeout);
						}, self.config.transitionTimeoutDelay);

						// dispatch transitionend for maximized sticky header
						$.pubsub('publish', 'vfdp.topnav.sticky.transitionend.maximized');
					}
				};

				// if animations are enabled, add classes to trigger transitions and handle transitionend
				if(!restrictAnimations && this.config.animate) {
					self.config.$search.addClass('notransition fade-out');
					self.config.$mainnav.addClass('notransition fade-out');
					self.config.$header[0].addEventListener('transitionend', headerAnimationComplete);
				}
				// display promobar without animations
				else {
					self.config.$promobar.removeClass('hide');
				}
			},

			toggleScrollEvents: function(data) {
				var self = data;
				if(topNavToggleScrollDisabled) {
					if($(window).scrollTop() > 0) {
						if(!self.config.$header.hasClass('sticky-scrolled')) {
							self.config.$header.addClass('sticky-scrolled');
						}
					} else {
						if(self.config.$header.hasClass('sticky-scrolled')) {
							self.config.$header.removeClass('sticky-scrolled');
						}
					}
				} else {
					var currentScroll = $(window).scrollTop();
					var isHideStickyNav = newStickyTopEnabled ? (currentScroll > lastScroll || lastScroll <= self.config.scroll) : true;
					self.toggleTransperantTopNav();
					if(currentScroll >= self.config.scroll && isHideStickyNav) {
						if(!self.config.$header.hasClass('sticky-minimized')) {
							self.minimizeStickyHeader();
						}
					} else {
						if(self.config.$header.hasClass('sticky-minimized')) {
							self.maximizeStickyHeader();
						}
					}
					lastScroll = currentScroll;
				}
			},

			unbindScrollEvents: function() {
				var self = this;

				self.maximizeStickyHeader(true); // restrictAnimations: true
				$(window).off('scroll', self.toggleScrollEvents);
			},

			/**
			 * Copies the sticky navigation classes to the body
			 * so that padding can be set correctly
			 **/
			toggleStickyState: function(disable) {
				var self = this,
					stickyClasses = ['sticky','sticky-small','sticky-medium','sticky-large'],
					removeClasses = [],
					addClasses = [];

				var disableSticky = (disable) ? true : false;

				// Check which classes are present
				stickyClasses.forEach(function(el) {
					if(self.config.$header.hasClass(el) && !disableSticky) {
						addClasses.push(el);
					} else {
						removeClasses.push(el);
					}
				});

				// Update the body tag accordingly
				$('body').removeClass(removeClasses.join(' ')).addClass(addClasses.join(' '));
			},

			/**
			 * Relocates the promobar for certain states like transparent topnav
			 **/
			relocatePromoBar: function() {
				var self = this;

				if (self.config.isNavTransparent && promoBarTopEnabled) {
					self.config.$promobarContainer.detach().prependTo(self.config.$topnav);
				}
			},

			/**
			* Initial DOM modifications
			**/
			_build : function() {
				var self = this;
				self.relocatePromoBar();
				self.toggleStickyState();
				self.updateBodyPadding();
			}

		};

		return topnavSticky.init();

	})();

	return topnavSticky;
});
